const LazyLoad = {
    install: (Vue, options) => (Vue.prototype.$lazyLoad = options),
};

export default LazyLoad;
